import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-user-guide',
    templateUrl: './user-guide.component.html',
    styleUrl: './user-guide.component.scss',
    standalone: false
})
export class UserGuideComponent {
  currentRoute: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.url.subscribe(url => {
      this.currentRoute = url[0].path;
    });
  }
}
